import React from "react";
import PropTypes from "prop-types";
import Toast from "react-bootstrap/Toast";

const EQHErrorToast = ({ id, errors, handleClose, isList }) => {
  const toastId = id || "eqh-error-toast";
  return (
    <Toast id={`${toastId}-toast`} onClose={handleClose} show={Boolean(errors?.length)} className="position-fixed zindex-1040 top-0 end-0 mt-3 me-3">
      <Toast.Header id={`${toastId}-toast-header`}>
        <strong className="me-auto fw-bold text-danger">
          <i className="fas fa-exclamation-triangle"></i> Error
        </strong>
        <small>Just Now</small>
      </Toast.Header>
      <Toast.Body id={`${toastId}-toast-body`} className="rounded">
        {(errors?.length && !isList) &&
          errors.map((err, idx) => (
            <React.Fragment key={`${toastId}-error-${idx}`}>{err}</React.Fragment>
          ))}
        {(errors?.length && isList) &&
          errors.map((err, idx) => (
            <li key={`${toastId}-error-${idx}`}>{err}</li>
          ))}
      </Toast.Body>
    </Toast>
  );
};

EQHErrorToast.propTypes = {
  id: PropTypes.string,
  errors: PropTypes.array,
  handleClose: PropTypes.func.isRequired,
  isList: PropTypes.bool,
};

export default EQHErrorToast;
